import React from 'react';
import { ModalDialog, ButtonBar } from 't-lib-ui/structure';
import { TextButton } from 't-lib-ui/widgets';
import './DeleteFolderModal.css';

interface DeleteFolderModalProps {
  show: boolean;
  folderName: string;
  feedCount: number;
  onDeleteFeeds: () => void;
  onKeepFeeds: () => void;
  onCancel: () => void;
}

const DeleteFolderModal: React.FC<DeleteFolderModalProps> = ({
  show,
  folderName,
  feedCount,
  onDeleteFeeds,
  onKeepFeeds,
  onCancel,
}) => {
  return (
    <ModalDialog
      show={show}
      title="Delete Folder"
      closeButton="close"
      onClose={onCancel}
      className="deleteFolderModal"
    >
      <p>
        The folder "<strong>{folderName}</strong>" contains {feedCount} feed{feedCount !== 1 ? 's' : ''}.
        What would you like to do?
      </p>
      <ButtonBar className="full-margin-top" align="right">
        <TextButton type="minor" onClick={onCancel} label="Cancel" />
        <TextButton type="minor" onClick={onKeepFeeds} label="Keep Feeds" />
        <TextButton type="major" className="dangerButton" onClick={onDeleteFeeds} label="Delete Feeds" />
      </ButtonBar>
    </ModalDialog>
  );
};

export default DeleteFolderModal;
